<template>
  <div
    class="home-block__content"
  >
    <h2 class="h2 home-block__heading mt0" >
      {{ content.heading }}
    </h2>
    <h3
      v-if="content.subheading"
      class="h3 home-block__subheading fw-semibold"
    >
      {{ content.subheading }}
    </h3>
    <p
      v-for="(paragraph, index) in content.copy"
      :key="index"
      :class="[
        `p`,
        index + 1 === content.copy.length ? `mb0` : ``,
      ]"
    >
      {{ paragraph }}
    </p>
    <div
      v-if="content.list"
      class="home-block__list">
      <ul>
        <li
          v-for="(point, index) in content.list"
          :key="index"
          class="home-block__list-item"
        >
          <img
            v-if="content.bullet"
            :src="content.bullet"
            alt="bullet"
          >
          <span>{{ point }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: `module-home-content`,

  props: {
    content: Object,
  },
};
</script>



// WEBPACK FOOTER //
// HomeContent.vue?ee6bdc42